export default {
  amazon: 'border border-neutral-300 rounded-xl px-8 py-12',
  callADoctorPlus: 'border border-[#1A416F] rounded-xl px-8 py-12',
  greenhouse: 'border border-neutral-300 rounded-xl px-8 py-12',
  k9ActivityClub: 'border border-neutral-300 rounded-xl px-8 py-12',
  k9CrazyDogClub: 'border border-neutral-300 rounded-xl px-8 py-12',
  kagome: 'border border-neutral-300 rounded-xl px-8 py-12',
  noDesignGuidelinesBlue: 'border border-neutral-200 rounded-2xl px-5 lg:px-8 py-8 lg:py-10',
  ossur: 'border border-neutral-300 rounded-xl px-8 py-12',
  petscreening: 'border border-neutral-300 rounded-xl px-8 py-12',
  pupJoy: 'border border-neutral-400 rounded-xl p-8',
  tenantPetCare: 'border border-neutral-300 rounded-2xl px-5 lg:px-8 py-8 lg:py-10',
  wishbone: 'border border-neutral-300 rounded-xl px-8 py-12',
};
